import { cn } from '@/lib/utils';

/** Fading rows: each is fainter than the one above it. */
const BARS = [
  { width: 'w-32', dot: 'bg-muted-foreground/25', bar: 'bg-muted-foreground/15' },
  { width: 'w-20', dot: 'bg-muted-foreground/15', bar: 'bg-muted-foreground/10' },
  { width: 'w-28', dot: 'bg-muted-foreground/10', bar: 'bg-muted-foreground/5' },
] as const;

/**
 * The "there is nothing here yet" drawing: three ghost rows.
 *
 * A sketch of the content that is missing reads faster than a large icon,
 * because it tells you what would have been on screen.
 */
export function EmptyIllustration({ className }: { className?: string }) {
  return (
    <div aria-hidden className={cn('flex flex-col gap-2.5', className)}>
      {BARS.map((row) => (
        <div key={row.width} className="flex items-center gap-2.5">
          <span className={cn('size-2.5 shrink-0 rounded-full', row.dot)} />
          <span className={cn('h-2.5 rounded-full', row.width, row.bar)} />
        </div>
      ))}
    </div>
  );
}
